<template>
  <v-dialog v-model="dialog" width="700" :fullscreen="fullscreen" scrollable>
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        {{ cardTitle }}
        <v-btn icon @click="fullscreen = !fullscreen">
          <v-icon>{{ !fullscreen ? 'fullscreen' : 'fullscreen_exit' }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <dangerous-informers-form
          :data="item"
          :is-edit="isEdit"
          :dialog-is-open="dialog"
          :is-fullscreen="fullscreen"
          @submit="submit"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import DangerousInformersForm from './DangerousInformersForm.vue';

export default {
  name: 'dangerous-informers-dialog',
  components: { DangerousInformersForm },
  mixins: [DialogBusMixin],
  data: () => ({
    item: null,
    isEdit: false,
    fullscreen: false,
  }),
  computed: {
    hasItem() {
      return !!this.item;
    },
    cardTitle() {
      const titles = [
        'Новый информер ОЯ',
        'Редактировать информер ОЯ',
      ];
      return titles[Number(this.hasItem)];
    },
  },
  methods: {
    submit(data) {
      this.$emit('submit', data);
      this.dialog = false;
    },
    beforeOpen({ item }) {
      this.item = item;
      this.isEdit = false;
      if (item) {
        this.isEdit = true;
        this.item.regionId = item.region.id;
      }
    },
  },
};
</script>

<style scoped>

</style>
